import { useEffect } from "react";

const useDebounce = (effect: any, dependency: any, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);
    return () => clearTimeout(handler);
  }, [...(dependency || []), delay]);
};

export default useDebounce;
